import { jsonp, ajax } from 'ThreeTerminal_base/base';

// 疫情页分享数
export const getVoteNum = async key => {
    const data = await jsonp('//survey.news.ifeng.com/api/getaccumulatorweight', {
        data: {
            format: 'js',
            key,
            serviceid: 2,
        },
        jsonpCallback: 'getaccumulator',
        cache: false,
    });

    return data.data && data.data.browse && data.data.browse[key] ? data.data.browse[key] : '';
};

// 疫情分享
export const vote = async key => {
    const data = await jsonp('//survey.news.ifeng.com/api/accumulator', {
        data: {
            format: 'js',
            key,
        },
        jsonpCallback: 'accumulator',
        cache: false,
    });

    return data.code === 1;
};
